module.exports = parcelRequire.resolve("dX9Cm");